import { render } from "./CadastroOrcamentoManual.vue?vue&type=template&id=2740d24b&scoped=true"
import script from "./CadastroOrcamentoManual.vue?vue&type=script&lang=js"
export * from "./CadastroOrcamentoManual.vue?vue&type=script&lang=js"

import "./CadastroOrcamentoManual.vue?vue&type=style&index=0&id=2740d24b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2740d24b"]])

export default __exports__